import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom'

import student_Store from '../store/student_store'
import admin_Store from '../store/admin_store'
import supervisor_Store from '../store/supervisor_store'
import Cookies from 'js-cookie'

const AuthRequire = ({ allowedRoles }) => {
  const location = useLocation()
  let roles = Cookies.get('type')?.split(',') ?? []

  const suffix = process.env.REACT_APP_SUFFIX_ROUTE

  const isExist = (obj) => Object.keys(obj).length > 0

  const isAuth = () => roles.includes(process.env.REACT_APP_STL) || roles.includes(process.env.REACT_APP_SUL) || roles.includes(process.env.REACT_APP_AL)
  return roles?.find((role) => {
    role = role.substring(0, 40)
    return allowedRoles?.includes(role)
  }) ? (
    <Outlet />
  ) : isAuth() ? (
    <Navigate to={`${suffix}/404`} replace />
  ) : (
    <Navigate to={`${suffix}/login`} state={{ from: location }} replace />
  )
}

export default AuthRequire
